function Table({
  headers = defaultValues.headers,
  data = defaultValues.data,
  type = defaultValues.type,
  actions = defaultValues.actions,
  actionsClass = defaultValues.actionsClass,
  headerClass = defaultValues.headerClass,
  rowClass = defaultValues.rowClass
}) {
  return (
    <div className="tableWrapper">
      <table className="tableGeneral">
        <thead>
          <tr className={headerClass}>
            {headers.map((item) => (
              <th key={item.id} className="tableCell"><strong>{item.text}</strong></th>
            ))}
            {type === 'actions' ? <th key='actionsHeader' className="tableCell"><strong>Acciones</strong></th> : null }
          </tr>
        </thead>
        <tbody>
          {data.map((item) => (
            <tr key={item.id} className={rowClass}>
              {item.fields.map((subItem) => (
                <td key={item.id + subItem.id} className="tableCell">{subItem.text}</td>
              ))}
              {type === 'actions' ? <td key={'actions' + item.id} className="tableCell">
                <div className={actionsClass} key={'div' + item.id}>
                  {actions.map((action) => (<div key={'actionDiv' + item.id + action.id}>
                    <button key={'action' + item.id + action.id} className='adminButtonFull' onClick={() => action.buttonFunction(item.id, item.fields)}>
                      {action.text}
                    </button>
                  </div>))}
                </div>
              </td> : null}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

const test = (id) => {console.log(id);}

const defaultValues = {
  headers: [{id: 0, text: 'Nombre'}, {id: 1, text: 'Documento'},{id: 2, text: 'Edad'}],
  data: [
    {id: '1a', fields: [
        {id: '0', text: 'Gómez Darío'},
        {id: '1', text: '12345'},
        {id: '2', text: '71'}
      ]
    },
    {id: '2b', fields: [
        {id: '0', text: 'Jaramillo Julio'},
        {id: '1', text: '54321'},
        {id: '2', text: '42'}
      ]
    },
    {id: '3c', fields: [
        {id: '0', text: 'Infante Pedro'},
        {id: '1', text: '67890'},
        {id: '2', text: '39'}
      ]
    }
  ],
  type: 'actions',
  actions: [{id: '0', text: 'probar', buttonFunction: test}],
  actionsClass: 'singleAction',
  headerClass: 'tableHead',
  rowClass: 'tableRow'
}

export default Table